'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _App = require('./App');

var _App2 = _interopRequireDefault(_App);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _selectors = require('./selectors');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import * as components from './components';
var App = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!actions.isAppLoaded(getState())) {
      promises.push(dispatch(actions.getApp()).then(function (result) {
        //console.log('app satisfied');
        return result;
      }));
    }

    return _promise2.default.all(promises);
  }
}], 'App')((0, _reactRedux.connect)(_selectors.mapStateToProps)(_App2.default));
//import * as constants from './constants';
//import reducer from './reducer';
//import * as types from './types';
exports.default = {
  App: App,
  actions: actions
  //reducer,
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/App/index.js
// module id = 1145
// module chunks = 0